/// <reference types="node" />
import { EnvConfigModel, EnvKey } from '../../models/env.types'

// used by lk_web_proxy
export const provideEnvConfigOld = (): EnvConfigModel => {
    const { livekid_env } = window.localStorage
    const {
        NODE_ENV,
        VUE_APP_ENV_NAME,
        VUE_APP_API_ENV,
        VITE_CRISP_PL,
        VITE_CRISP_DE,
        VITE_CRISP_ES,
        VITE_CRISP_NA
    } = process.env
    // SAFETY: build env / localStorage override are set from the EnvKey list by the deploy config
    const api_env = (livekid_env || VUE_APP_API_ENV) as EnvKey
    // SAFETY: VUE_APP_ENV_NAME is set per deploy target from the EnvKey list
    return {
        env: (VUE_APP_ENV_NAME ?? 'localhost') as EnvKey,
        env_overridden: Boolean(livekid_env),
        api_env,
        is_production:
            ['production', 'wekita'].includes(VUE_APP_ENV_NAME ?? '') &&
            NODE_ENV == 'production',
        is_dev: NODE_ENV != 'production',
        crisp_website_id: {
            pl: VITE_CRISP_PL,
            de: VITE_CRISP_DE,
            ch: VITE_CRISP_DE,
            es: VITE_CRISP_ES,
            sa: VITE_CRISP_ES,
            na: VITE_CRISP_NA
        }
    }
}
